import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ChevronDown } from 'lucide-react';
import { storeUrl } from './storeBase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Mobile-only accordion for the Catalog item in the slide-down nav.
 * First tap expands the row to reveal the storefront's Featured
 * Collections as pills (same data + look as the desktop mega menu).
 * A second tap, or tapping the "All products" link, navigates to the
 * full catalog.
 */
const MobileCatalogAccordion = ({ active }) => {
  const [open, setOpen] = useState(false);
  const [collections, setCollections] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || collections !== null) return;
    let cancelled = false;
    setLoading(true);
    axios.get(`${API}/storefront/featured-collections`)
      .then((r) => { if (!cancelled) setCollections(r.data?.items || []); })
      .catch(() => { if (!cancelled) setCollections([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const hasCollections = Array.isArray(collections) && collections.length > 0;

  return (
    <div className={`sf-mobile-accordion ${open ? 'open' : ''}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className={`sf-mobile-menu-item sf-mobile-accordion-trigger ${active ? 'active' : ''}`}
        data-testid="sf-nav-mobile-catalog"
      >
        <span>Catalog</span>
        <ChevronDown size={18} className="sf-mobile-accordion-chev" aria-hidden="true" />
      </button>

      {open && (
        <div className="sf-mobile-accordion-body" data-testid="sf-nav-mobile-catalog-body">
          {loading && (
            <p className="sf-mobile-accordion-empty">Loading…</p>
          )}
          {!loading && hasCollections && (
            <div className="sf-mega-pills">
              {collections.map((c) => (
                <Link
                  key={c.handle}
                  to={storeUrl(`/catalog?collection=${encodeURIComponent(c.handle)}`)}
                  className="sf-mega-pill"
                  data-testid={`sf-nav-mobile-catalog-${c.handle}`}
                >
                  <span className="sf-mega-pill-label">{c.title}</span>
                </Link>
              ))}
            </div>
          )}
          <Link
            to={storeUrl('/catalog')}
            className="sf-mobile-accordion-viewall"
            data-testid="sf-nav-mobile-catalog-all"
          >
            All products →
          </Link>
        </div>
      )}
    </div>
  );
};

export default MobileCatalogAccordion;
